'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var $dom = {};

var cacheDom = function cacheDom() {
  $dom.body = $('body');

  /* -- Mobile UI Elements -- */
  $dom.mobileNavSearchForm = $('[data-mobile-nav-search-form]');

  $dom.indexSearchForm = $('[data-index-search-form]');
  $dom.indexSearchFormInput = $('[data-index-search-form] .search-input');

  $dom.searchDrawerMobile = $('[data-search-drawer-mobile]');
  $dom.searchDrawerMobileInput = $('[data-search-drawer-mobile] .search-input');
  $dom.searchDrawerMobileClose = $('[data-search-drawer-close]');

  $dom.headerNavRight = $('.header-nav-right-mobile');

  /* -- Desktop UI Elements -- */
  $dom.desktopSearchIcon = $('[data-search-toggle]');
  $dom.searchDrawerDesktop = $('[data-search-drawer-desktop]');
  $dom.searchDrawerDesktopInput = $('[data-search-drawer-desktop-input]');
};

var openSearchDrawerMobile = function openSearchDrawerMobile() {
  $dom.searchDrawerMobile.addClass('is-active');
  $dom.searchDrawerMobileClose.addClass('is-active');
  $dom.headerNavRight.addClass('hidden');
  $('.findify-autocomplete').show();
  setTimeout(function () {
    $dom.searchDrawerMobileInput.focus();
  }, 250);
};

var closeSearchDrawerMobile = function closeSearchDrawerMobile() {
  $dom.searchDrawerMobileInput.blur();
  $('.findify-autocomplete').hide();
  $dom.searchDrawerMobile.removeClass('is-active');
  $dom.searchDrawerMobileClose.removeClass('is-active');
  $dom.headerNavRight.removeClass('hidden');
};

var openSearchDrawerDesktop = function openSearchDrawerDesktop() {
  $dom.desktopSearchIcon.addClass('is-active');
  $dom.searchDrawerDesktop.addClass('is-active');
  $('.findify-autocomplete').show();
  setTimeout(function () {
    $dom.searchDrawerDesktopInput.focus();
  }, 250);
};

var closeSearchDrawerDesktop = function closeSearchDrawerDesktop() {
  $dom.searchDrawerDesktopInput.blur();
  $('.findify-autocomplete').hide();
  $dom.desktopSearchIcon.removeClass('is-active');
  $dom.searchDrawerDesktop.removeClass('is-active');
};

var bindUIActions = function bindUIActions() {

  /* -------------------------------------------
      *   Mobile UI Actions
      * ------------------------------------------- */
  $dom.indexSearchForm.on('click submit', function (event) {
    event.preventDefault();
    openSearchDrawerMobile();
  });

  $dom.mobileNavSearchForm.on('click submit', function (event) {
    event.preventDefault();
    openSearchDrawerMobile();
  });

  $dom.searchDrawerMobileClose.on('click', closeSearchDrawerMobile);

  /* -------------------------------------------
      *   Desktop UI Actions
      * ------------------------------------------- */

  $dom.desktopSearchIcon.on('click', function (_ref) {
    var self = _ref.currentTarget;

    if ($(self).hasClass('is-active')) {
      closeSearchDrawerDesktop();
    } else {
      openSearchDrawerDesktop();
    }
  });

  $(document).on('click', '.findify-components-autocomplete--suggestion-item__suggestion', function () {
    closeSearchDrawerDesktop();
  });
};

var init = exports.init = function init() {
  cacheDom();
  bindUIActions();
};

exports.default = {
  init: init
};